import React from "react";
import { FaHome, FaSignOutAlt } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import "../../../assets/css/topbar.css";

function Topbar() {
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("adminUser");
    navigate("/superadmin");
  };

  return (
    <div className="topbar">
      <div className="topbar-left">
        <h2 className="text-white">SuperAdmin Desk</h2>
      </div>
      <div className="topbar-right">
        <Link
          className="text-white text-decoration-none"
          to="/SuperAdminDashboard"
        >
          <div className="icon-circle">
            <FaHome className="icon" />
          </div>
        </Link>

        <div className="icon-circle" onClick={handleLogout}>
          <FaSignOutAlt className="icon" />
        </div>
      </div>
    </div>
  );
}

export default Topbar;
